import React from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Button, Tooltip } from '@mui/material';
import { Brightness4, Brightness7, Shield, LocalCafe } from '@mui/icons-material';

const Header = ({ themeMode, toggleTheme }) => (
  <AppBar
    position="static"
    sx={{
      background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(44,62,80,1) 50%, rgba(52,0,60,1) 100%)',
      color: 'white',
      boxShadow: 'none',
    }}
  >
    <Toolbar
      sx={{
        justifyContent: 'space-between',
        padding: '1rem',
        flexWrap: 'wrap',
      }}
    >
      {/* Left-Side: Title, Badge, and Subtitle */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {/* Title and Badge */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {/* Title */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: 'bold',
              color: 'white',
            }}
          >
            Zerō
          </Typography>

          {/* Zero Knowledge Badge */}
          <Tooltip title="Passwords are generated entirely in your browser. We can't see or store your data.">
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                padding: '0.3rem 0.6rem',
                borderRadius: '12px',
                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                },
              }}
            >
              <Shield sx={{ color: 'white', marginRight: '0.5rem', fontSize: '1.2rem' }} />
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 'bold',
                  color: 'white',
                }}
              >
                Knowledge
              </Typography>
            </Box>
          </Tooltip>
        </Box>

        {/* Subtitle */}
        <Typography
          variant="subtitle2"
          sx={{
            color: 'rgba(255, 255, 255, 0.8)',
            fontStyle: 'italic',
          }}
        >
          Completely Secure Passwords
        </Typography>
      </Box>

      {/* Right-Side: Actions */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        {/* Support Button */}
        <Tooltip title="Every contribution keeps this app running!">
          <Box>
            <Button
              href="https://paypal.me/ClairmontOne?country.x=US&locale.x=en_US"
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<LocalCafe />}
              sx={{
                textTransform: 'none',
                fontWeight: 'bold',
                borderColor: 'white',
                color: 'white',
                display: { xs: 'none', sm: 'flex' },
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: 'white',
                },
              }}
            >
              Fuel My Creativity
            </Button>
            <IconButton
              href="https://paypal.me/ClairmontOne?country.x=US&locale.x=en_US"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'white',
                display: { xs: 'inline-flex', sm: 'none' }, // Show icon-only on mobile
              }}
              aria-label="Fuel my creativity"
            >
              <LocalCafe />
            </IconButton>
          </Box>
        </Tooltip>

        {/* Theme Toggle */}
        <IconButton
          onClick={toggleTheme}
          aria-label="Toggle theme"
          sx={{
            color: 'white',
            '&:hover': {
              color: 'rgba(255, 255, 255, 0.8)',
            },
          }}
        >
          {themeMode === 'light' ? <Brightness4 /> : <Brightness7 />}
        </IconButton>
      </Box>
    </Toolbar>
  </AppBar>
);

export default Header;
